var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1019,
    height: 972,
    viewBox: "0 0 1019 972",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476.337 40.1089L57.0316 638.939",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M960.24 378.941L540.934 977.771",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M718.288 209.525L298.983 808.355",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M969.731 488.609L370.901 69.304",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M800.314 730.561L201.484 311.255",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M630.898 972.512L32.0682 553.207",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M597.312 124.817L178.007 723.647",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M839.264 294.233L419.958 893.063",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M885.022 609.585L286.192 190.28",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M715.606 851.537L116.776 432.231",
    stroke: "#F9EED2",
    strokeWidth: 12.6586
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M266.113 402.869L284.247 505.711",
    stroke: "#F9EED2",
    strokeWidth: 8.43909
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M223.759 463.357L326.601 445.223",
    stroke: "#F9EED2",
    strokeWidth: 8.43909
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M592.773 451.31L610.907 554.152",
    stroke: "#F9EED2",
    strokeWidth: 8.43909
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M550.419 511.798L653.261 493.664",
    stroke: "#F9EED2",
    strokeWidth: 8.43909
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M435.53 160.918L453.664 263.76",
    stroke: "#F9EED2",
    strokeWidth: 8.43909
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M393.176 221.406L496.018 203.272",
    stroke: "#F9EED2",
    strokeWidth: 8.43909
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 686.548,
    cy: 381.755,
    r: 32.7015,
    transform: "rotate(35 686.548 381.755)",
    stroke: "#F9EED2",
    strokeWidth: 8.43909
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.156,
    cy: 538.999,
    r: 32.7015,
    transform: "rotate(35 396.156 538.999)",
    stroke: "#F9EED2",
    strokeWidth: 8.43909
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.864,
    cy: 418.023,
    r: 32.7015,
    transform: "rotate(35 480.864 418.023)",
    stroke: "#F9EED2",
    strokeWidth: 8.43909
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.d2a39ca0fcdaa2ff893cd1273ac8ebf3.svg";
export { ForwardRef as ReactComponent };